export default __webpack_public_path__ + "static/media/logo gif .1ac14775.webp";